import React from 'react';
import '../App';

var github = require('../images/github.svg');
var linkedIn = require('../images/linkedin.svg');
const foot = {
    zIndex: 900
}

class Footer extends React.Component {
    render(){
        return (
            <div className="FIcon">
                <div>
                    <a href="https://github.com/StevenLy369">
                        <img style={foot} src={github} height="35" width="35" alt="Github" />
                    </a>
                </div>
                <div className="FRight">
                    <a href="https://www.linkedin.com/in/stevenly369/">
                        <img style={foot} src={linkedIn} height="35" width="35" alt="LinkedIn" />
                    </a>
                </div>
            </div>
        );
    }
}

export default Footer;